import React from 'react';

function ChevronRight(props: object) {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.70005 6L1.70005 12L0.300049 10.6L4.90005 6L0.300048 1.4L1.70005 -6.11959e-08L7.70005 6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ChevronRight;
